function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.75c0-.688-.563-1.25-1.25-1.25H12.5c-.688 0-1.25.563-1.25 1.25H1.875V5h9.375c0 .688.563 1.25 1.25 1.25h1.25C14.438 6.25 15 5.687 15 5h3.125V3.75H15zM13.75 13.75H12.5c-.688 0-1.25.563-1.25 1.25H1.875v1.25h9.375c0 .688.563 1.25 1.25 1.25h1.25c.688 0 1.25-.563 1.25-1.25h3.125V15H15c0-.688-.563-1.25-1.25-1.25zM6.875 8.125h-1.25c-.688 0-1.25.563-1.25 1.25h-2.5v1.25h2.5c0 .688.563 1.25 1.25 1.25h1.25c.688 0 1.25-.563 1.25-1.25h10v-1.25h-10c0-.688-.563-1.25-1.25-1.25z",
    fill: props.color
  }));
}

export default SvgIconFilterFilled;